function Dashboard () {
    return (
        <div>
            <span>Dashboard</span>
        </div>
    )
}

export default Dashboard;